<template>
	<el-container style="width: 80%; margin: 0 auto">
		<BreadCrumb></BreadCrumb>
		<el-card class="pay-type" shadow="never">
			<div slot="header">
				<h3>对公转账</h3>
			</div>
			<div style="overflow: hidden; width: 56%; margin: 40px auto 100px">
				<div style="overflow: hidden">
					<div class="tab-pane-left">
						<div class="corporate-info-all" ref="htmlContent">
							<div>
								支付金额：<b>{{ (orderInfo.orderBasic.totalAmount + orderInfo.orderBasic.freightAmount).toFixed(2) }}元</b>
								<span v-if="orderInfo.orderBasic.freightAmount > 0">(包含{{ orderInfo.orderBasic.freightAmount }}元运费)</span>
							</div>
							<div>
								订单号：<b>{{ $route.query.orderId }}</b>
							</div>

							<div class="corporate-info">
								<div class="pay-title">对公转账信息<i class="el-icon-document-copy icon-copy" title="点击复制对公转账信息" @click="copyMsg"></i></div>
								<div>单位名称：北京品读文化发展有限公司</div>
								<div>单位银行账号：110060907018010020725</div>
								<div>开户行：交通银行北京胜古园支行</div>
								<div>开户银行行号：301100000494</div>
							</div>
							<div class="corporate-info-tradeComment">
								汇款识别码：<b style="font-size: 20px; color: #f56c6c; font-style: normal">{{ orderInfo.orderBasic.tradeComment }}</b>
								<i class="el-icon-document-copy icon-copy" title="点击复制汇款识别码" @click="copyTradeNo"></i>
							</div>
							<div>
								<div style="font-size: 18px; font-weight: 600">注意事项</div>
								<div style="font-size: 14px">1. 请务必在转账备注中<span style="color: red">填写汇款识别码</span>，以便及时核对款项</div>
								<div style="font-size: 14px">2. 若您汇款后3个工作日内订单状态未更新，请您联系客服进行处理</div>
							</div>
						</div>
						<div>
							<el-button type="primary" plain size="small" @click="copyAllMsg">复制全部信息</el-button>
						</div>
					</div>
					<div class="tab-pane-right">
						<div class="tab-pane-right-img">
							<img src="../../assets/images/dgzz.jpg" alt="" />
						</div>
						<div style="margin-top: 20px">
							<el-button type="primary" size="small" @click="viewOrder">查看订单</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-card>
	</el-container>
</template>
<script>
import BreadCrumb from '@/components/Breadcrumb/index.vue';
import { getFilesPreview, postFilesUpload } from '@/api/file/file';
import TMessage from '@/utils/TMessage';
import User from '@/utils/User';
import { postConsumerOrderPayOfflineTransfer } from '@/api/order/pay';
import { getConsumerOrderInfo } from '@/api/order/order';
import { mapActions } from 'vuex';
import CopyText from '@/utils/CopyText';
export default {
	name: 'OfflineTransfer',
	data() {
		return {
			payModal: false,
			//转账信息
			transferInfo: {
				tradeNo: '',
				corporateInfo: '',
				corporateInfoUrl: ''
			},
			orderInfo: null
		};
	},
	components: {
		BreadCrumb
	},
	created() {
		this.getOrderInfo();
		//包含VIP则是会员订单，否则是图书订单
		const listPath = this.$route.query.orderId.indexOf('VIP') >= 0 ? '/UserCenter/VIPOrder' : '/UserCenter/BookOrder';
		const breadcrumbs = [
			{
				path: '/Home',
				name: '首页'
			},
			{
				path: listPath,
				name: '我的订单'
			},
			{
				path: '/OrderDet?orderId=' + this.$route.query.orderId,
				name: '订单详情'
			},
			{ name: '订单支付' }
		];
		this.setBreadcrumbList(breadcrumbs);
	},
	methods: {
		getHtmlString() {
			// 返回要复制的 HTML 字符串
			return this.$refs.htmlContent.innerHTML;
		},
		onCopySuccess() {
			alert('复制成功！');
		},
		onCopyError(err) {
			console.error('复制失败:', err);
			alert('复制失败');
		},
		copyMsg() {
			//复制corporate-info中的信息
			const corporateInfo = document.querySelector('.corporate-info').innerText;
			CopyText.copyMessage(corporateInfo);
		},

		copyAllMsg() {
			// 复制corporate-info-all中的信息
			const corporateInfo = document.querySelector('.corporate-info-all').innerText;
			CopyText.copyMessage(corporateInfo);
		},
		copyTradeNo() {
			//复制corporate-info-tradeComment中的信息
			const corporateInfo = document.querySelector('.corporate-info-tradeComment').innerText;
			CopyText.copyMessage(corporateInfo);
		},
		...mapActions('Settings', ['setBreadcrumbList']),
		//获取订单信息
		async getOrderInfo() {
			let res = await getConsumerOrderInfo(this.$route.query.orderId);
			if (res.code === 200) {
				this.orderInfo = res.data;
			}
		},

		//出发input标签事件
		updateImg() {
			this.$refs.updateImgInput.click();
		},

		//选择后的事件
		async updateChange(event) {
			let Max_Size = 1024 * 100; //100KB
			let file = event.target.files[0];
			if (file.type === 'image/jpeg' || file.type === 'image/png') {
				if (file.size * 0.0009766 > Max_Size) {
					TMessage.warning('转账凭证大小不能大于100MB，请重新上传');
					return;
				} else {
					let res = await postFilesUpload(file);
					if (res.code == 200) {
						let url = res.data;
						const prefix = '/third/files/info/';
						const key = url.replace(prefix, '');
						this.transferInfo.corporateInfo = key;
						this.getFilesInfo(key);
						TMessage.success('转账凭证上传成功');
					}
				}
			} else {
				TMessage.warning('转账凭证只能上传图片类型，请重新上传');
			}
		},

		// 获取文件详情
		async getFilesInfo(key) {
			try {
				const response = await fetch(`/webL_api/third/files/info/${key}`, {
					headers: {
						Authorization: 'Bearer ' + User.getToken()
					}
				});
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				const arrayBuffer = await response.arrayBuffer();
				const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
				const imageUrlData = URL.createObjectURL(blob);
				this.$set(this.transferInfo, 'corporateInfoUrl', imageUrlData);
			} catch (error) {
				console.error('获取图片失败:', error);
				return null;
			}
		},

		handleConfirm() {
			if (!this.transferInfo.corporateInfo) {
				TMessage.warning('请上传转账凭证');
				return;
			} else {
				this.transferInfo.tradeNo = this.$route.query.orderId;
				postConsumerOrderPayOfflineTransfer(this.transferInfo).then(res => {
					if (res.code == 200) {
						TMessage.success('转账凭证上传成功');
						this.viewOrder();
					}
				});
			}
		},
		//关闭支付弹框
		handleClose() {
			this.payModal = false;
		},

		viewOrder() {
			this.$router.push({ path: '/OrderDet', query: { orderId: this.$route.query.orderId } });
		}
	}
};
</script>

<style lang="less" scoped>
.pay-type {
	margin-bottom: 30px;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	border-radius: 15px;
	h3 {
		margin: 0;
		font-weight: 400;
		font-size: 18px;
		color: #333333;
	}

	.icon-copy {
		cursor: pointer;
		color: #999999;
		font-size: 14px;
		margin-left: 6px;
	}
}
.money {
	font-size: 26px;
	font-weight: 700;
	color: #f60;
}

.qrcode {
	display: inline-block;
	margin-bottom: 10px;
	overflow: hidden;
	width: 198px;
	height: 198px;
}

.pay-title {
	line-height: 30px;
	font-size: 18px !important;
	font-weight: 600;
}

.tab-pane-left {
	width: 50%;
	float: left;

	h6 {
		padding: 0;
		margin: 0;
		font-size: 24px;
		margin-bottom: 10px;
	}

	div {
		margin-bottom: 10px;
		font-size: 14px;
		line-height: 26px;
	}

	b {
		font-size: 18px;
		margin: 10px 0;
		// display: block;
		color: #f56c6c;
	}
}

.tab-pane-right {
	width: 49%;
	float: left;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.tab-pane-right-img {
	width: 70%;
	height: 100%;
	margin: 30px auto 0;
}

.tab-pane-right-img img {
	height: 100%;
	width: 100%;
}

/deep/ .el-dialog__header {
	border-bottom: 1px solid #e8e8e8;
	margin-right: 0;
	background: #f5f7fa;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
	color: #3a434f;
	font-size: 24px;
}

/deep/ .el-dialog__footer {
	border-top: 1px solid #e8e8e8;
	padding: 18px;
}

/deep/ .el-dialog__body .el-form-item__label {
	line-height: 26px;
}
</style>